import * as React from "react";
import PropTypes from 'prop-types';

const SvgVideoNew = props => {
  if (props.id !== "_svgvideonew") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 2c9.94 0 18 8.06 18 18s-8.06 18-18 18S2 29.94 2 20 10.06 2 20 2z" fill="#fff" fillOpacity={0.92} /><path fillRule="evenodd" clipRule="evenodd" d="M30.757 22.206l-16.004 9.447c-1.667.984-3.753-.242-3.753-2.206V10.553c0-1.964 2.086-3.19 3.753-2.206l16.004 9.447c1.663.982 1.663 3.43 0 4.412zM14 9.67c-.667-.393-1.501.097-1.501.883v18.894c0 .786.834 1.276 1.501.883l16.004-9.448a1.03 1.03 0 000-1.764L14.001 9.67z" fill="#202020" /></svg>;
};

SvgVideoNew.displayName = "_svgvideonew";
SvgVideoNew.propTypes = {
  id: PropTypes.string
};
SvgVideoNew.defaultProps = {
  id: ''
};
export default SvgVideoNew;